// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:21:32

export default {
  "id": "gta-grand-vegas-crime",
  "slug": "gta-grand-vegas-crime",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/828864726be944c2bff67fa68d505e96-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/828864726be944c2bff67fa68d505e96/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "GTA: Grand Vegas Crime",
      "description": "Grand Vegas Crime is an open-world action game set in a sprawling city inspired by Las Vegas. Players take on the role of a daring gangster looking to rise through the criminal underworld. The game offers intense missions, thrilling car chases, and fierce shootouts against rival gangs and law enforcement. Grand Vegas Crime delivers an adrenaline-pumping experience filled with crime, action, and adventure.",
      "instructions": "E - Enter/Exit Vehicles\nWASD - Move\nMouse Mouse - Look Around\nLeft Mouse Click - Hit/Shoot\nEscape - Pause Game",
      "genres": [
        "Shooter",
        "Simulation"
      ],
      "tags": [
        "car",
        "city",
        "helicopter",
        "mission",
        "running"
      ]
    },
    "zh-CN": {
      "title": "GTA：拉斯维加斯犯罪",
      "description": "《大赌城犯罪》是一款以拉斯维加斯为灵感的开放世界动作游戏。玩家扮演一位敢于冒险的犯罪分子，目标是爬升至犯罪世界的巅峰。游戏提供紧张的任务、刺激的赛车追逐和与敌对帮派及执法机构的激烈枪战。《大赌城犯罪》带来一场充满犯罪、动作和冒险的肾上腺素激荡体验。",
      "instructions": "E - 进入/退出车辆\nWASD - 移动\n鼠标鼠标 - 环顾四周\n左键点击 - 打击/射击\nEscape - 暂停游戏",
      "genres": [
        "射击",
        "模拟"
      ],
      "tags": [
        "汽车",
        "城市",
        "直升机",
        "任务",
        "奔跑"
      ]
    },
    "zh-TW": {
      "title": "GTA：大維加斯犯罪",
      "description": "大維加斯犯罪是一個開放世界的動作遊戲，背景設定在一個類似拉斯維加斯的廣闊城市。玩家扮演一名膽識過人的黑幫份子，努力在犯罪地下世界中爬升。遊戲提供緊張刺激的任務、驚險的車追逐戰，以及與敵對黑幫和警方激烈的槍戰。大維加斯犯罪為玩家帶來一場充滿犯罪、動作和冒險的興奮體驗。",
      "instructions": "E - 選擇/離開載具\nWASD - 移動\n滑鼠滑鼠 - 四處張望\n左鍵點擊 - 打擊/射擊\nEsc - 暫停遊戲",
      "genres": [
        "射擊",
        "模擬"
      ],
      "tags": [
        "車輛",
        "城市",
        "直升機",
        "任務",
        "奔跑"
      ]
    },
    "zh-HK": {
      "title": "GTA: 大維加斯犯罪",
      "description": "大維加斯犯罪是一個開放世界的動作遊戲，設置在受拉斯維加斯啟發的廣闊城市中。玩家將扮演一名勇闖江湖的犯罪分子，尋求在犯罪世界中崛起。遊戲提供激烈任務、刺激的車追逐和與敵對幫派及执法機關的激烈槍戰。大維加斯犯罪帶來一個充滿犯罪、動作和冒險的刺激體驗。",
      "instructions": "E - 開啟/關閉載具\nWASD - 移動\n滑鼠滑鼠 - 遠望\n左鍵按鈕 - 攻擊/射擊\nEscape - 暂停遊戲",
      "genres": [
        "射擊遊戲",
        "模擬遊戲"
      ],
      "tags": [
        "車輛",
        "城市",
        "直升機",
        "任務",
        "奔跑"
      ]
    },
    "ja": {
      "title": "GTA: グランド・ベガス・クライム",
      "description": "グランド・ベガス・クライムは、ラスベガスをインスパイアした広大な都市を舞台にしたオープンワールドアクションゲームです。プレイヤーは大胆なギャングとして、犯罪の地下世界を上昇する役割を演じます。ゲームは、激しいミッション、興奮に満ちた車の追跡、敵対するギャングや警察との激しい銃撃戦を提供します。グランド・ベガス・クライムは、犯罪、アクション、冒険で満ちたアドレナリンで満ちた体験を提供します。",
      "instructions": "E - 車両への乗降\nWASD - 移動\nマウス マウス - 周囲を見回す\n左クリック - 攻撃/撃つ\nEscape - ゲーム一時停止",
      "genres": [
        "射撃ゲーム",
        "シミュレーションゲーム"
      ],
      "tags": [
        "車",
        "都市",
        "ヘリコプター",
        "ミッション",
        "走る"
      ]
    },
    "ko": {
      "title": "GTA: 그랜드 베가스 범죄",
      "description": "그랜드 베가스 크라임은 라스베가스를 모티브로 한 광범위한 도시에서发生的 오픈 월드 액션 게임입니다. 플레이어는 도전적인 범죄자 역할을 맡아 범죄 세계에서 성장하는 것을 목표로 합니다. 게임은 강력한 미션, 흥미진진한 차량 추격과 적대团伙 및 경찰과의 치열한 총격전을 제공합니다. 그랜드 베가스 크라임은 범죄, 액션, 모험으로 가득 찬肾上腺 자극을 받는 경험을 제공합니다.",
      "instructions": "E - 차량 진입/이탈\nWASD - 이동\n마우스 - 둘러보기\n왼쪽 마우스 클릭 -殴打/사격\nEscape - 게임 일시정지",
      "genres": [
        "슈터",
        "시뮬레이션"
      ],
      "tags": [
        "차",
        "도시",
        "헬리콥터",
        "임무",
        "도망치다"
      ]
    },
    "fr": {
      "title": "GTA : Grand Vegas Crime",
      "description": "Grand Vegas Crime est un jeu d'action open-world inspiré par Las Vegas. Les joueurs prennent le rôle d'un gangster audacieux cherchant à gravir les échelons du monde criminel. Le jeu propose des missions intenses, des poursuites en voiture palpitantes et des affrontements meurtriers contre des gangs rivaux et les forces de l'ordre. Grand Vegas Crime offre une expérience à l'adrénaline, remplie de crime, d'action et d'aventure.",
      "instructions": "E - Entrer/Sortir des véhicules\nWASD - Se déplacer\nClic gauche de la souris - Regarder autour\nClic gauche de la souris - Frapper/Tirer\nÉchap - Mettre le jeu en pause",
      "genres": [
        "Tirailleur",
        "Simulation"
      ],
      "tags": [
        "car",
        "ville",
        "hélicoptère",
        "mission",
        "course"
      ]
    }
  }
};
